import { render } from "./PostPanel.vue?vue&type=template&id=f10af222&scoped=true"
import script from "./PostPanel.vue?vue&type=script&lang=js"
export * from "./PostPanel.vue?vue&type=script&lang=js"

import "./PostPanel.vue?vue&type=style&index=0&id=f10af222&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator.1LIZRQUYRIVXOVB\\github-classroom\\MUICCS\\cs340prj-Atiwat-R\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10af222"]])

export default __exports__